import { ACADEMIC_YEARS, academicYearReducer } from '@module/AcademicYears/redux/reducer'
import { ACHIEVEMENT_RECORDS, achievementRecordsReducer } from '@module/AchievementRecords/redux/reducer'
import { ASSESSMENT, assessmentReduser as assessmentReducer } from '@module/Assessment/redux/reducer'
import { ASSESSMENT_EC, assessmentECReducer } from '@module/AssessmentEC/redux/reducer'
import { LOGS_ASSESSMENT, LogsAssessmentReducer } from '@module/AssessmentLogs/redux/reducer'
import { ASSESSMENT_MARKS, assessmentMarksReducer } from '@module/AssessmentMarks/redux/reducer'
import { ATTENDANCES, attendanceReducer } from '@module/Attendance/redux/reducer'
import { AUTH, authReducer } from '@module/Auth/redux/reducer'
import { CALENDAR, calendarReduser as calendarReducer } from '@module/Calendar/redux/reducer'
import { CATEGORY, categoryReduser } from '@module/Category/redux/reducer'
import { CHAT, chatReduser } from '@module/Chat/redux/reducer'
import { ChAT_GROUP_MESSAGE, chatGroupReducer } from '@module/ChatGroup/redux/reducer'
import { CITIES, cityReducer } from '@module/City/redux/reducer'
import { COLOR_PALETTES, colorPaletteReducer } from '@module/ColorPalette/redux/reducer'
import Mail, { MAIL } from '@module/ComposeEmail/redux/reducer'
import { CONFERENCES, conferenceReducer } from '@module/Conference/redux/reducer'
import { CONTRACT, contractReducer } from '@module/ContractInformation/redux/reducer'
import { COUNTRYS, countryReducer } from '@module/Country/redux/reducer'
import { COURSE_CAMPAIGNS, courseCampaignReducer } from '@module/Course/activate/redux/reducer'
import { COURSE_CREATES, courseCreateReducer } from '@module/Course/create/redux/reducer'
import { COURSE_TRANSERS, courseTransferReducer } from '@module/CourseTransfer/redux/reducer'
import { DEMO_LESSON_EVALUATION, demoLessonEvaluationReducer } from '@module/DemoLesson/redux/reducer'
import { DEPARTMENTS, departmentReducer } from '@module/Departments/redux/reducer'
import { ACCOMMODATIONS, accommodationReducer } from '@module/DormitoryApp/redux/reducer'
import { EDUCATION_PLACES, educationPlaceReducer } from '@module/EducationPlace/redux/reducer'
import { ENROLLMENTS, enrollmentReducer } from '@module/Enrollment/redux/reducer'
import { FEEDBACK, feedbackReducer } from '@module/Feedback/redux/reducer'
import { MODULE_FILES, moduleFileReducer } from '@module/Files/ModuleFiles/redux/reducer'
import { FORMS, formsReducer } from '@module/Forms/redux/reducer'
import { GENERAL_ADMISSION, generalAdmissionReducer } from '@module/GeneralAdmission/redux/reducer'
import { GROUPING, groupReducer } from '@module/Groups/redux/reducer'
import { GUESTS, guestsReducer } from '@module/GuestUsers/redux/reducer'
import { HR, hrAdmissionReducer } from '@module/HRAdmission/redux/reducer'
import { HELP_DESK, helpDeskReducer } from '@module/HelpDesk/redux/reducer'
import { INQUIRY, inquiryReducer } from '@module/Inquiry/redux/reducer'
import { VIDEOS, introVideosReducer } from '@module/IntroVideos/redux/reducer'
import { JOB_POSITION, jobPositionReducer } from '@module/JobPosition/redux/reducer'
import { LESSONS, lessonsReducer } from '@module/Lesson/redux/reducer'
import { E_LIBRARYS, eLibraryReducer } from '@module/Library/redux/reducer'
import { MEALS, mealReducer } from '@module/Meals/redux/reducer'
import { MOBILE_SETTING_STATE, mobileSettingsReducer } from '@module/MobileSettings/redux/reducer'
import { MODULES_OUTCOMES, modulesOutcomeReducer } from '@module/ModuleOutcome/redux/reducer'
import { MODULE_REGISTRATION, moduleRegistrationReducer } from '@module/ModuleRegistration/redux/reducer'
import { CCLS_MODULES, cclsModuleReducer } from '@module/Modules/activate/redux/reducer'
import { MODULES, modulesReducer } from '@module/Modules/create/redux/reducer'
import { OPEN_LINK, openLinkReducer } from '@module/OpenLink/redux/reducer'
import { EXTERNAL_PAYMENTS, paymentsReducer } from '@module/Payments/redux/reducer'
import Player, { PLAYER } from '@module/Player/redux/reducer'
import { PRE_FOUNDATION, preFoundationReducer } from '@module/PreFoundation/redux/reducer'
import { PRE_MODERATION, preModerationReducer } from '@module/PreModeration/redux/reducer'
import { LEVEL, levelReducer } from '@module/QualityAssurance/redux/level/reducer'
import { QUESTIONS, questionsReducer } from '@module/Question/redux/reducer'
import { CLUB_EVENTS, clubEventSlice } from '@module/ReadersClub/redux/reducer'
import { RECRUITMENT_INQUIRYS, recruitmentInquirySlice } from '@module/RecruitmentInquiry/redux/reducer'
import { REPORTS, reportReducer } from '@module/Reports/redux/reducer'
import { RESERVATION_ROOM, reservationRoomReducer } from '@module/ReservationRoom/redux/reducer'
import { ROLES, roleReducer } from '@module/Roles/redux/reducer'
import { SD_FEEDBACK, sdFeedbackReducer } from '@module/SDFeedback/redux/reducer'
import { SEMESTER, semesterReducer } from '@module/Semester/redux/reducer'
import { SHOP, shopReducer } from '@module/Shop/redux/reducer'
import { ST_COURSE, stCourseApplicationReducer } from '@module/ShortCourseAdmission/redux/reducer'
import { SHORT_TERM_COURSE, stcReducer } from '@module/ShortTermCourse/redux/reducer'
import { STAFFS, staffReducer } from '@module/Staff/redux/reducer'
import { STATES, stateReducer } from '@module/State/redux/reducer'
import { STATS_MAIN, statsReducer } from '@module/Stats/redux/reducer'
import { STUDENTS, studentReducer } from '@module/Student/redux/reducer'
import { STUDENT_ADMISSION, studentAdmissionReducer } from '@module/StudentAdmission/redux/reducer'
import { STUDENT_DASHBOARD, studentDashboardReducer } from '@module/StudentDashboard/redux/reducer'
import { STUDENT_INQUIRIES, studentInquiriesReducer } from '@module/StudentInquiries/redux/reducer'
import { TEACHER_DASHBOARD, teacherDashboardReducer } from '@module/TeacherDashboard/redux/reducer'
import { TEACHING_WORKLOAD, teachingWorkloadReducer } from '@module/TeachingWorkload/redux/reducer'
import { TIMETABLE, timetableReducer } from '@module/Timetable/redux/reducer'
import { TYPE, typesReducer } from '@module/Types/redux/reducer'
import { VACANCY_POSITIONS, vacancyPositionReducer } from '@module/VacancyPosition/redux/reducer'
import { VACATION, vacationReducer } from '@module/Vacation/redux/reducer'
import { WORK_PLAN, workPlanReducer } from '@module/WorkPlan/redux/reducer'
import { combineReducers } from '@reduxjs/toolkit'
import { ACADEMIC_MISCONDUCT, academicMisconductReducer } from '@src/module/AcademicMisconduct/redux/reducer'
import { ACCOUNTS, accountReducer } from '@src/module/Account/redux/reducer'
import { QUIZ_ASSESSMENT, quizReducer } from '@src/module/QuizAssessment/redux/reducer'
import { STUDENT_QUIZ_ASSESSMENT, studentQuizReducer } from '@src/module/QuizAssessmentStudent/redux/reducer'
import { layoutReducer } from '@src/redux/layout/reducer'
import { connectRouter } from 'connected-react-router'

import { history } from './store'

const rootReducer = combineReducers({
  router: connectRouter(history),
  layout: layoutReducer,
  [AUTH]: authReducer,
  [ACCOUNTS]: accountReducer,
  [ACADEMIC_YEARS]: academicYearReducer,
  [LESSONS]: lessonsReducer,
  [COURSE_CAMPAIGNS]: courseCampaignReducer,
  [COURSE_TRANSERS]: courseTransferReducer,
  [COUNTRYS]: countryReducer,
  [COLOR_PALETTES]: colorPaletteReducer,
  [CLUB_EVENTS]: clubEventSlice,
  [ChAT_GROUP_MESSAGE]: chatGroupReducer,
  [LEVEL]: levelReducer,
  [ACCOMMODATIONS]: accommodationReducer,
  [SEMESTER]: semesterReducer,
  [CCLS_MODULES]: cclsModuleReducer,
  [CALENDAR]: calendarReducer,
  [GROUPING]: groupReducer,
  [STAFFS]: staffReducer,
  [COURSE_CREATES]: courseCreateReducer,
  [MEALS]: mealReducer,
  [MOBILE_SETTING_STATE]: mobileSettingsReducer,
  [MODULES]: modulesReducer,
  [MODULE_REGISTRATION]: moduleRegistrationReducer,
  [STUDENTS]: studentReducer,
  [ENROLLMENTS]: enrollmentReducer,
  [ASSESSMENT]: assessmentReducer,
  [LOGS_ASSESSMENT]: LogsAssessmentReducer,
  [ASSESSMENT_MARKS]: assessmentMarksReducer,
  [ACADEMIC_MISCONDUCT]: academicMisconductReducer,
  [ASSESSMENT_EC]: assessmentECReducer,
  [DEPARTMENTS]: departmentReducer,
  [FEEDBACK]: feedbackReducer,
  [SD_FEEDBACK]: sdFeedbackReducer,
  [DEMO_LESSON_EVALUATION]: demoLessonEvaluationReducer,
  [INQUIRY]: inquiryReducer,
  [REPORTS]: reportReducer,
  [MODULES_OUTCOMES]: modulesOutcomeReducer,
  [MODULE_FILES]: moduleFileReducer,
  [ACHIEVEMENT_RECORDS]: achievementRecordsReducer,
  [ATTENDANCES]: attendanceReducer,
  [HR]: hrAdmissionReducer,
  [FORMS]: formsReducer,
  [STUDENT_DASHBOARD]: studentDashboardReducer,
  [TEACHER_DASHBOARD]: teacherDashboardReducer,
  [TEACHING_WORKLOAD]: teachingWorkloadReducer,
  [OPEN_LINK]: openLinkReducer,
  [PRE_FOUNDATION]: preFoundationReducer,
  [PRE_MODERATION]: preModerationReducer,
  [PLAYER]: Player,
  [VIDEOS]: introVideosReducer,
  [CITIES]: cityReducer,
  [STATES]: stateReducer,
  [JOB_POSITION]: jobPositionReducer,
  [VACANCY_POSITIONS]: vacancyPositionReducer,
  [MAIL]: Mail,
  [ROLES]: roleReducer,
  [ST_COURSE]: stCourseApplicationReducer,
  [SHOP]: shopReducer,
  [QUESTIONS]: questionsReducer,
  [QUIZ_ASSESSMENT]: quizReducer,
  [STUDENT_QUIZ_ASSESSMENT]: studentQuizReducer,
  [CATEGORY]: categoryReduser,
  [E_LIBRARYS]: eLibraryReducer,
  [STUDENT_ADMISSION]: studentAdmissionReducer,
  [STUDENT_INQUIRIES]: studentInquiriesReducer,
  [EDUCATION_PLACES]: educationPlaceReducer,
  [GUESTS]: guestsReducer,
  [STATS_MAIN]: statsReducer,
  [CONTRACT]: contractReducer,
  [EXTERNAL_PAYMENTS]: paymentsReducer,
  [TYPE]: typesReducer,
  [GENERAL_ADMISSION]: generalAdmissionReducer,
  [SHORT_TERM_COURSE]: stcReducer,
  [VACATION]: vacationReducer,
  [CHAT]: chatReduser,
  [TIMETABLE]: timetableReducer,
  [WORK_PLAN]: workPlanReducer,
  [RESERVATION_ROOM]: reservationRoomReducer,
  [RECRUITMENT_INQUIRYS]: recruitmentInquirySlice,
  [HELP_DESK]: helpDeskReducer,
  [CONFERENCES]: conferenceReducer,
})

const reducers = (state, action) => {
  if (action.type === 'RESET_APP') {
    const { router, layout, [AUTH]: auth } = state
    state = { router, layout, [AUTH]: auth }
  }
  return rootReducer(state, action)
}

export default reducers
